<template>
  <div class="empty-state">
    <div class="empty-state__emoji">
      (&gt;_&lt;)
    </div>

    <div class="empty-state__text">
      <p v-if="query">Oops! No results for <strong>{{ this.query }}</strong>.</p>
      <p v-else>Oops! Nothing to show here.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',

  props: {
    query: String
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  text-align: center;

  &__emoji {
    padding-bottom: 15px;
    color: map-get($color-util, 'muted');
    font: {
      weight: 700;
      size: 3.5rem;
    }
  }

  &__text {
    p {
      margin: 1em 0;
      line-height: 140%;
    }
  }

  // Responsiveness
  @include media(map-get($breakpoint, 'medium')) {
    &__emoji {
      font-size: 3rem;
    }

    &__text {
      font-size: 0.9rem;
    }
  }
}
</style>
